export default "__VITE_PUBLIC_ASSET__607ba1e1__"